import { render, staticRenderFns } from "./SettingsClientTypes.vue?vue&type=template&id=70295760&scoped=true"
import script from "./SettingsClientTypes.vue?vue&type=script&lang=js"
export * from "./SettingsClientTypes.vue?vue&type=script&lang=js"
import style0 from "./SettingsClientTypes.vue?vue&type=style&index=0&id=70295760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70295760",
  null
  
)

export default component.exports